import { useNavigate } from "@solidjs/router";
import { Component, createEffect, JSX, Show } from "solid-js";
import { useAuth } from "../store/authStore";
import { trace } from "../lib/trace";

interface AuthWrapperProps {
  children: JSX.Element;
}

/**
 * Authentication wrapper that checks auth status on mount
 * Redirects to home page if not authenticated
 */
export const AuthWrapper: Component<AuthWrapperProps> = (props) => {
  const { isAuthenticated, isCheckingAuth } = useAuth();
  const navigate = useNavigate();

  createEffect(() => {
    const checking = isCheckingAuth();
    const authed = isAuthenticated();
    trace.auth("AuthWrapper: evaluating", {
      isCheckingAuth: checking,
      isAuthenticated: authed,
      path: typeof window !== "undefined" ? window.location.pathname : "unknown",
    });

    // Only redirect if auth check is complete and user is not authenticated
    if (!checking && !authed) {
      trace.auth("AuthWrapper: redirecting to / (not authenticated)");
      navigate("/", { replace: true });
    }
  });

  return (
    <Show
      when={!isCheckingAuth()}
      fallback={
        <div style={{ display: "flex", "align-items": "center", "justify-content": "center", "min-height": "100vh" }}>
          <span class="loading-spinner loading-spinner-lg" />
        </div>
      }>
      <Show
        when={isAuthenticated()}
        fallback={
          <div style={{ display: "flex", "align-items": "center", "justify-content": "center", "min-height": "100vh", color: "var(--text-secondary)" }}>
            <span>Please log in to continue</span>
          </div>
        }>
        {props.children}
      </Show>
    </Show>
  );
};
